import React from 'react';
import { Section } from './ui/Section';
export function ProductOverview() {
  const pillars = [{
    title: 'Calculadora',
    subtitle: 'De Supervivencia'
  }, {
    title: 'Radar',
    subtitle: 'De Clientes'
  }, {
    title: 'Oficina',
    subtitle: 'En una Página'
  }, {
    title: 'Contratos',
    subtitle: 'Blindados'
  }, {
    title: 'Psicología',
    subtitle: 'Del Sí'
  }, {
    title: 'Plan',
    subtitle: '14 Días'
  }];
  return <Section data-id="element-180">
      <div className="text-center mb-12" data-id="element-181">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-182">
          🏆 MEGAPACK™: TU NEGOCIO BAJO CONTROL
        </h2>
        <p className="text-xl md:text-2xl text-brand-accent font-medium mb-3" data-id="element-183">
          6 Tomos + 3 Bonos — Del Caos al Sistema
        </p>
        <p className="text-neutral-400 text-lg" data-id="element-184">
          400+ páginas — Todo resuelto.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-185">
        {pillars.map((pillar, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-xl p-6 text-center hover:border-brand-accent/50 transition-colors" data-id="element-186">
            <div className="text-brand-accent font-bold text-lg mb-1" data-id="element-187">
              {pillar.title}
            </div>
            <div className="text-neutral-400 text-sm" data-id="element-188">{pillar.subtitle}</div>
          </div>)}
      </div>
    </Section>;
}